import React, { Component } from 'react';
import { connect } from 'react-redux';

import { withStyles } from '@material-ui/core/styles';

import * as fastDataReducers from '../reducer';
import * as userStationsReducers from '../../system/reducer/UserStationsReducers';
import * as healthDataReducers from '../../health-data/reducer';

import * as actionManager from '../action-mgr';
import * as healthDataActionManager from '../../health-data/action-mgr';

import * as strings from '../../helpers/strings';
import { scrollTo, setFastDataStationId } from '../../helpers/common';
import * as mqttMgr from '../../helpers/MqttMgr';
import { mapMarkerIcon } from '../../helpers/constants';

import { topicPrefix as healthTopicPrefix, ERROR_TYPE_NOT_CONNECTED } from '../../health-data/constants';

import { topicPrefix, imgTopicPrefix } from '../constants';


const styles = {
  root: {
    width: "100%",
    height: 550,
    backgroundColor: "grey"
  },
  healthPoint: {
    height: 10,
    width: 10,
    background: "#B71C1C",
    borderRadius: 5,
    marginRight: 5
  },
  statushealthPoint: {
    height: 10,
    width: 10,
    background: "#B71C1C",
    borderRadius: 5,
    marginRight: 5,
    bottom: "-27px",
    position: "absolute",
    left: "50%",
    transform: "translateX(-50%)"
  }
}

class UserStationsMap extends Component {

  constructor() {
    super();

    this._renderMap = this._renderMap.bind(this);
    this.handleSelect = this.handleSelect.bind(this);
    this.handleHealthData = this.handleHealthData.bind(this);
    this.updateHealthPointer = this.updateHealthPointer.bind(this);
    this.handleFastData = this.handleFastData.bind(this);
  }

  componentDidMount = () => {
    const { stations, setInitialHealthData, fetchLatestHealthData } = this.props;
    if (stations.length) {
      stations.forEach(station => {
        mqttMgr.addSubscriptionTopic(`${healthTopicPrefix}${station.name}`, this.handleHealthData);
      });

      this._renderMap();

      setInitialHealthData(stations);
      fetchLatestHealthData(stations)
        .then(stationHealths => {
          setTimeout(() => {
            stationHealths.forEach(health => {
              this.updateHealthPointer(health.stationId, health.errorType);
            });
          }, 500);
        });
    }
  }

  shouldComponentUpdate = () => {
    return false;
  }

  componentWillUnmount() {
    const { stations } = this.props;

    stations.forEach(station => {
      mqttMgr.removeSubscriptionTopic(`${healthTopicPrefix}${station.name}`);
    });
  }

  updateHealthPointer = (stationName, errorType) => {
    var healthPointer = document.getElementById(`point_${stationName}`);
    var statushealthPointer = document.getElementById(`status_point_${stationName}`);

    if (healthPointer && statushealthPointer !== null) {
      healthPointer.style.backgroundColor = errorType === ERROR_TYPE_NOT_CONNECTED ? "#B71C1C" : (errorType === 1 ? "#00C853" : "#FB8C00");
      statushealthPointer.style.backgroundColor = errorType === ERROR_TYPE_NOT_CONNECTED ? "#B71C1C" : (errorType === 1 ? "#00C853" : "#FB8C00");
    }
  }

  handleHealthData = healthData => {
    this.updateHealthPointer(healthData.stationId, healthData.errorType);

    const { setHealthData } = this.props;
    setHealthData(healthData);
  }

  handleFastData(fastData) {
    const { stationTimeOffset, addFastData } = this.props;
    const targetDate = new Date(fastData.timestamp);

    var timestamp = targetDate.getTime() / 1000 + targetDate.getTimezoneOffset() * 60 // Current UTC date/time expressed as seconds since midnight, January 1, 1970 UTC
    var offsets = stationTimeOffset.dstOffset * 1000 + stationTimeOffset.rawOffset * 1000 // get DST and time zone offsets in milliseconds
    var localdate = new Date(timestamp * 1000 + offsets) // Date object containing current time of target location
    var refreshDate = new Date() // get current date again to calculate time elapsed between targetDate and now
    var millisecondselapsed = refreshDate - targetDate // get amount of time elapsed between targetDate and now
    localdate.setMilliseconds(localdate.getMilliseconds() + millisecondselapsed) // update localdate to account for any time elapsed

    fastData.timestamp = localdate.getTime();
    addFastData(fastData);
  }

  handleSelect = newStationId => {
    const { selectedStationId, selectStation, stations, selectStationHealth, setSitePhotos, getStationTimeOffset } = this.props;
    if (selectedStationId !== newStationId) {
      if (selectedStationId) {
        const stationName = stations.filter(station => station.id === selectedStationId)[0].name;
        mqttMgr.removeSubscriptionTopic(`${topicPrefix}${stationName}`);
        mqttMgr.removeSubscriptionTopic(`${imgTopicPrefix}${stationName}`);
      }
      setFastDataStationId(newStationId);

      const station = stations.filter(station => station.id === newStationId)[0];
      const stationName = station.name;
      getStationTimeOffset(station)
        .then(() => {
          mqttMgr.addSubscriptionTopic(`${topicPrefix}${stationName}`, this.handleFastData);
        })
      mqttMgr.addSubscriptionTopic(`${imgTopicPrefix}${stationName}`, setSitePhotos);
      selectStation(newStationId);
      selectStationHealth(stationName);
    }
  }

  // working version2
  _renderMap = () => {
    const { stations, classes } = this.props;
    const GoogleMaps = window.google.maps;
    var map = new GoogleMaps.Map(document.getElementById(strings.idMapStations), {
      zoom: 8 // Set a default zoom level
    });
  
    // Attempt to get the user's current location
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        position => {
          const userLocation = {
            lat: position.coords.latitude,
            lng: position.coords.longitude
          };
          map.setCenter(userLocation); // Set map center to user's location
          map.setZoom(5); // Optional: set a zoom level for the initial load
  
        },
        () => {
          console.error("Geolocation service failed.");
        }
      );
    } else {
      console.error("Your browser doesn't support geolocation.");
    }
  
    var bounds = new GoogleMaps.LatLngBounds();
  
    stations.forEach(station => {
      let markerData = {
        position: {
          lat: station.latitude,
          lng: station.longitude
        },
        map,
        icon: mapMarkerIcon,
        title: station.name
      };
      let marker = new GoogleMaps.Marker(markerData);
  
      let infowindow = new GoogleMaps.InfoWindow({
        content: `
          <div>
            <div id="point_${station.name}" class="${classes.statushealthPoint} blink-effect"></div>
            <div>
              <div style="display: flex; align-items: center; margin-bottom: 5px;">
                <div id="status_point_${station.name}" class="${classes.healthPoint}" style="margin-right: 5px;"></div>
                <span style="font-weight: bold;">${station.name}</span>
              </div>
              <div style="font-size: 9px; font-weight: bold; color: #252525;">
                ${station.description || "No description available"}
              </div>
            </div>
          </div>
        `
      });
    
      infowindow.addListener('domready', () => {
        const infoWindows = document.querySelectorAll('.gm-style-iw-c');
        infoWindows.forEach(iwOuter => {
          iwOuter.style.flexDirection = 'row-reverse';
          iwOuter.style.justifyContent = 'center';
          iwOuter.style.alignItems = 'center';
          iwOuter.style.paddingTop = '10px';
          iwOuter.style.boxShadow = ' 0 1px 1px 2px rgba(0, 0, 0, 0.1)'; 
          iwOuter.style.webkitBoxShadow = ' 0 1px 2px 1px rgba(0, 0, 0, 0.1)';
        });
      });
  
      marker.addListener('click', () => {
        infowindow.open(map, marker);
        this.handleSelect(station.id);
      });
  
      infowindow.open(map, marker);
      bounds.extend(marker.position);
    });
  
    // This will ensure that all markers fit within the map's bounds
    map.fitBounds(bounds);
  };
  
  render = () => {
    const { classes } = this.props;
    return (
      <div id={strings.idMapStations} className={classes.root} />
    )
  }
}

const mapStateToProps = state => ({
  stations: userStationsReducers.getStations(state),
  selectedStationId: fastDataReducers.getSelectedStationId(state),
  stationTimeOffset: fastDataReducers.getStationTimeOffset(state),

  healthByStationId: healthDataReducers.getByStationId(state),
  healthStationCount: healthDataReducers.getLiveHealthDataList(state).length
});

const mapDispatcherToProps = {
  selectStation: actionManager.selectStation,
  addFastData: actionManager.addFastData,
  setSitePhotos: actionManager.setSitePhotos,
  getStationTimeOffset: actionManager.getStationTimeOffset,

  setHealthData: healthDataActionManager.setHealthData,
  setInitialHealthData: healthDataActionManager.setInitialHealthData,
  fetchLatestHealthData: healthDataActionManager.fetchLatestHealthData,
  selectStationHealth: healthDataActionManager.selectStation,
}

export default connect(mapStateToProps, mapDispatcherToProps)(
  withStyles(styles)(UserStationsMap)
) 